import { ManufacturerAction, EManufacturerActions } from '../actions/manufacturer.action';
import { IManufacturerState, initialManufacturerState } from '../state/manufacturer.state';

export function manufacturerReducers(state = initialManufacturerState, action: ManufacturerAction): IManufacturerState {
    switch (action.type) {
      
        case EManufacturerActions.GetAllManufacturersSuccess: {
            return {
                ...state,
                getAllManufacturersSuccess: action.payload,
                getAllManufacturersError: null
            };
        }
        case EManufacturerActions.GetAllManufacturersError: {
            return {
                ...state,
                getAllManufacturersError: action.payload,
                getAllManufacturersSuccess: null
            };
        }
        case EManufacturerActions.GetAddManufacturerSuccess: {
            return {
                ...state,
                getAddManufacturerSuccess: action.payload,
                getAddManufacturerError: null
            };
        }
        case EManufacturerActions.GetAddManufacturerError: {
            return {
                ...state,
                getAddManufacturerError: action.payload,
                getAddManufacturerSuccess: null
            };
        }
        case EManufacturerActions.GetEditManufacturerSuccess: {
            return {
                ...state,
                getEditManufacturerSuccess: action.payload,
                getEditManufacturerError: null
            };
        }
        case EManufacturerActions.GetEditManufacturerError: {
            return {
                ...state,
                getEditManufacturerError: action.payload,
                getEditManufacturerSuccess: null
            };
        }
        case EManufacturerActions.GetManufacturerBystatusIdSuccess: {
            return {
                ...state,
                getmanufacturerBystatusIdSuccess: action.payload,
                getmanufacturerBystatusIdError: null
            };
        }
        case EManufacturerActions.GetManufacturerBystatusIdError: {
            return {
                ...state,
                getmanufacturerBystatusIdError: action.payload,
                getmanufacturerBystatusIdSuccess: null
            };
        }
        default:
        return state;
}
}
